export const iconSizes = { sm: 16, md: 20, lg: 24, xl: 36, xxl: 40 } as const;
